import { gql, useQuery } from "@apollo/client";
import {
  SharedTransactionsQueryQuery,
  SharedTransactionsQueryQueryVariables,
//   TransactionGroup,
} from "../../../schemaTypes";

export const sharedTransactionsQuery = gql`
  query SharedTransactionsQuery(
    $offset: Int!
    $limit: Int!
    $walletId: String!
    $recipientWalletId: String!
  ) {
    sharedTransactions(
      offset: $offset
      limit: $limit
      walletId: $walletId
      recipientWalletId: $recipientWalletId
    ) {
      createdAt
      transactions {
        id
        amount
        charge
        reference
        type
        status
        currency
        transferTypes
        wallet {
          id
          balance
          currency
          barterId
          flAccountReference
          owner {
            id
            customer {
              id
              firstname
              lastname
            }
            # createdAt
            # updatedAt
          }
          createdAt
          updatedAt
        }
        recipientWallet {
          id
          balance
          currency
          barterId
          flAccountReference
          owner {
            id
            customer {
              id
              firstname
              lastname
            }
            # createdAt
            # updatedAt
          }
          createdAt
          updatedAt
        }
        user {
          id
          # createdAt
          # updatedAt
        }
        createdAt
        updatedAt
      }
    }
  }
`;

export interface WithSharedTransactions {
  myTransactions: any;
  loading: boolean;
}

interface Props {
  variables: SharedTransactionsQueryQueryVariables;
  children: (data: WithSharedTransactions) => React.ReactElement | null;
}

export const SharedTransactions: React.FC<Props> = ({ children, variables }) => {
  const { data, loading } = useQuery<
    SharedTransactionsQueryQuery,
    SharedTransactionsQueryQueryVariables
  >(sharedTransactionsQuery, {
    variables, // ✅ actually pass props.variables to the query
    fetchPolicy: "cache-and-network", // optional: keeps cache + updates from network
  });

  return children({
    myTransactions: data?.sharedTransactions ?? [], // ✅ safely fallback to []
    loading,
  });
};
